import { RiCloseLargeLine, RiPushpinFill } from '@remixicon/react'
import { useSidebar } from 'src/hook/useSidebar'
import i18n from 'src/i18n'
import { useUser } from 'src/hook/useUser'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import clsx from 'clsx'
import { HeaderProps } from './header.types'
import { Wrapper } from './header.styles'

const Header = ({ pinnedPostsLength }: HeaderProps) => {
  const { closeSidebar } = useSidebar()
  const { theme } = useUser()

  return (
    <Wrapper
      className={clsx(
        '_text-gray-900 _d-flex _align-items-center _justify-content-between _px-5 _py-4 _border-bottom _border-gray-200 _position-sticky',
        {
          '_bg-gray-100': theme === ThemeMode.DARK,
          '_bg-white': theme === ThemeMode.LIGHT
        }
      )}
    >
      <div className="_d-flex _align-items-center _justify-content-between">
        <RiPushpinFill size={24} className="_mr-3" />
        <h2 className="_font-18 _font-weight-bold _mb-0">
          {i18n.t('feed.pinnedPosts.header.title')} <span>({pinnedPostsLength})</span>
        </h2>
      </div>

      <button
        className="_border-0 hot-button _d-flex _p-2 _justify-content-center _align-items-center"
        title={i18n.t('pin_post.highlights.buttons.hide_highlights')}
        onClick={closeSidebar}
      >
        <RiCloseLargeLine />
      </button>
    </Wrapper>
  )
}

export default Header
